import { useContext } from 'react'
import AppContext from 'contexts/AppContext'
import { ApplicationType } from 'constants/enums/applicationTypes'
import tfbank_logo_white_without_shield from 'img/tf-logos/tfbank-text-logo-white.svg'
import tfbank_logo_black_without_shield from 'img/tf-logos/tfbank-text-logo-black.svg'
import tfbank_logo_black_powered_by_avarda from 'img/tf-logos/tfbank-powered-by-avarda-black.svg'
import tfbank_logo_white_powered_by_avarda from 'img/tf-logos/tfbank-powered-by-avarda-white.svg'

const marketsWithShield = ['no']

export function useLogoHelper() {
	const { market, applicationType: contextApplicationType } =
		useContext(AppContext)
	const storedType = sessionStorage.getItem(
		'applicationType',
	) as ApplicationType | null
	const applicationType = contextApplicationType ?? storedType ?? undefined
	const shield =
		marketsWithShield.includes(market.toLowerCase()) &&
		(!applicationType || applicationType === ApplicationType.Card)

	return {
		shouldUseShield: shield,
		whiteLogo: shield
			? tfbank_logo_white_powered_by_avarda
			: tfbank_logo_white_without_shield,
		blackLogo: shield
			? tfbank_logo_black_powered_by_avarda
			: tfbank_logo_black_without_shield,
	}
}
